export type Article = {
  id: string
  title: string
  cover: string
  tag: string
  meta: string
  category: string
}

export const articles: Article[] = [
  {
    id: 'a1',
    title: '2026 QS世界大学排名重磅发布！MIT蝉联榜首',
    cover: 'https://images.unsplash.com/photo-1607237138185-eedd9c632b0b?w=600',
    tag: '热点',
    meta: '指南者留学 · 2.3w阅读',
    category: '推荐',
  },
  {
    id: 'a2',
    title: '英国G5名校研究生申请GPA要求最新汇总',
    cover: 'https://images.unsplash.com/photo-1583468982228-19f19164aee2?w=600',
    tag: '干货',
    meta: '申请指南 · 1.8w阅读',
    category: '推荐',
  },
  {
    id: 'a3',
    title: '985双非如何冲刺港三新二？真实案例拆解',
    cover: 'https://images.unsplash.com/photo-1576487236230-eaa4afe68192?w=600',
    tag: '案例',
    meta: '录取案例 · 9.5k阅读',
    category: '申请动态',
  },
  {
    id: 'a4',
    title: '美研CS申请文书这样写，offer直接拿到手软',
    cover: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=600',
    tag: '文书',
    meta: '指南者顾问 · 6.2k阅读',
    category: '留学经验',
  },
  {
    id: 'a5',
    title: '雅思7.0+如何在三个月内冲刺到位？',
    cover: 'https://images.unsplash.com/photo-1455390582262-044cdead277a?w=600',
    tag: '语言',
    meta: '语言备考 · 5.1k阅读',
    category: '留学经验',
  },
  {
    id: 'a6',
    title: '商科申请的隐形门槛，95%的人都忽略了',
    cover: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600',
    tag: '申请解析',
    meta: '专业解析 · 8.9k阅读',
    category: '申请解析',
  },
  {
    id: 'a7',
    title: '指南者留学服务全流程介绍：从规划到入学',
    cover: 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=600',
    tag: '服务',
    meta: '指南者留学 · 1.2w阅读',
    category: '指南者服务',
  },
]
